import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SimpleButtonComponent, TitleContentComponent } from 'ngx-zcs-components';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { SettingsBlockComponent } from './settings-block.component';
import { SettingsFirebaseBlock } from '../settings-firebase/settings-firebase.block';
import { ConfigurationSectionComponent } from '../configuration-section/configuration-section.component';
import { UsersSectionComponent } from '../users-section/users-section.component';
import { SettingsAwsBlock } from '../settings-aws/settings-aws.block';
import { SystemPortingModule } from '../porting/system-porting/system-porting.module';
import { NotificationConfigurationModule } from '../notification-configuration/notification-configuration.module';


@NgModule({
  declarations: [
    SettingsAwsBlock,
    SettingsBlockComponent,
    SettingsFirebaseBlock,
  ],
  imports: [
    CommonModule,
    ConfigurationSectionComponent,
    MatButtonModule,
    MatIconModule,
    NotificationConfigurationModule,
    SimpleButtonComponent,
    SystemPortingModule,
    TitleContentComponent,
    TranslateModule,
    UsersSectionComponent,
  ],
  exports: [
    SettingsBlockComponent,
  ],
})
export class SettingsBlockModule {}
